/* global jQuery */

import 'select2';

// eslint-disable-next-line func-names
(function ($) {
  class GFWooDiscountsAddon {
    constructor() {
      this.localizedData = window.rfs_gf_woo_disc_addon_strings;
      this.select2data = this.localizedData.select2;

      this.selectors = {
        fields: '.js-select2',
        choices: '.gform-settings-choice',
      };

      this.fields = $(this.selectors.fields);
      this.choices = $(this.selectors.choices);

      if (this.fields.length) {
        this.init();
      }

      if (this.choices.length) {
        this.choicesInit();
      }
    }

    getAjaxAction = (field) => {
      const type = field.attr('data-type');
      let action = '';

      switch (type) {
        case 'coupon':
          action = 'get_coupons';
          break;
        default:
          break;
      }

      return `rfs_gf_woo_disc_${action}`;
    };

    getPlaceholder = (field) => {
      const type = field.attr('data-type');

      return this.select2data.placeholder[type] || '';
    };

    getSelectedValue = (field) => {
      const type = field.attr('data-type');

      return this.select2data.selected[type] || '';
    };

    init() {
      $.each(this.fields, (i, el) => {
        const field = $(el);
        const defaultvalues = this.getSelectedValue(field);

        if (defaultvalues.length) {
          defaultvalues.forEach((defaultvalue) => {
            const newOption = new Option(
              defaultvalue.text,
              defaultvalue.id,
              true,
              true,
            );
            field.append(newOption).trigger('change');
          });
        }

        field.select2({
          placeholder: this.getPlaceholder(field),
          ajax: {
            delay: 250,
            url: this.localizedData.ajaxUrl,
            data: (params) => {
              return {
                action: this.getAjaxAction(field),
                page: params.page || 1,
                search: params.term,
              };
            },
            processResults: (data) => {
              return data;
            },
          },
        });
      });
    }

    choicesInit() {
      this.choices.each((i, el) => {
        const choice = $(el);
        const inputs = choice.find(
          'input[type="checkbox"]:checked, input[type="radio"]:checked',
        );

        inputs.each((index, input) => {
          $(input).trigger('click').trigger('click');
        });
      });
    }
  }

  // eslint-disable-next-line no-new
  new GFWooDiscountsAddon();
})(jQuery);
